"use client";

import { useId } from "react";

type BrandPatternProps = {
  className?: string;
};

export function BrandPattern({ className }: BrandPatternProps) {
  const wrapperClassName = `pointer-events-none absolute inset-0 overflow-hidden opacity-40${className ? ` ${className}` : ""}`;
  const id = useId().replaceAll(":", "");
  const gradientId = `brandPatternGradient-${id}`;
  const gridId = `brandPatternGrid-${id}`;

  return (
    <div aria-hidden className={wrapperClassName}>
      <svg
        className="pointer-events-none absolute inset-0 h-full w-full"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <radialGradient id={gradientId} cx="50%" cy="50%" r="70%">
            <stop offset="0%" stopColor="rgba(255,255,255,0.12)" />
            <stop offset="60%" stopColor="rgba(143,247,196,0.06)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0)" />
          </radialGradient>
          <pattern id={gridId} width="200" height="200" patternUnits="userSpaceOnUse">
            <path
              d="M0 0 L200 200 M200 0 L0 200"
              stroke="rgba(255,255,255,0.04)"
              strokeWidth="0.6"
            />
            <circle cx="100" cy="100" r="35" stroke="rgba(255,255,255,0.05)" fill="none" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${gridId})`} />
        <rect width="100%" height="100%" fill={`url(#${gradientId})`} />
      </svg>
    </div>
  );
}
